import React, {useEffect, useState} from "react";
import ConnectWallet from "../components/ConnectWallet";
import { useModal } from "../context/ModalContext";
import { NFTContract as readOnlyNFT } from "../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Landing() {
  const {
    account,
    web3api,
    isWalletAlreadyConnected,
    disconnectWalletFromApp,
    connectWallet,
    NFTContract,
  } = useModal();
  const [count, setCount] = React.useState(1);
  const [userMinted, setUserMinted] = React.useState(0);
  const [totalSupply, setTotalSupply] = React.useState(0);
  const [mintPrice, setMintPrice] = React.useState(0);

  const increment = () => {
    if (count === 5) return;
    setCount((prevCount) => prevCount + 1);
  };

  const decrement = () => {
    if (count === 1) return;
    setCount((prevCount) => prevCount - 1);
  };

  useEffect(() => {
    readOnlyNFT.methods
      .totalSupply()
      .call()
      .then((supply) => {
        setUserMinted(supply);
      });
      readOnlyNFT.methods
      .maxSupply()
      .call()
      .then((balance) => {
        setTotalSupply(balance);
      });
    readOnlyNFT.methods
      .price()
      .call()
      .then((price) => {
        setMintPrice(price);
      }
    );
  }, []);

  const handleMint = async () => {
    try {
        const gasAmount = await NFTContract.methods
          .mint(count)
          .estimateGas({
            from: account[0],
            value: mintPrice * count,
          })
          .catch((error) => {
            error.message =
              "There was an error minting your NFT. Please try again.";
            toast.error(error.message);
          });
        const gasPrice = await web3api.eth.getGasPrice();
        const gasCost = gasAmount * gasPrice;
        await NFTContract.methods
          .mint(count)
          .send({
            from: account[0],
            gas: gasAmount*2,
            gasPrice: Math.floor(gasPrice*1.5),
            value: mintPrice * count,
          })
          .on("receipt", (receipt) => {
            toast.success("NFT minted successfully");
            setUserMinted((userMinted) => parseInt(userMinted) + 1);
          })
          .on("error", (error) => {
            error.message =
              "There was an error minting your NFT. Please try again.";
            toast.error(error.message);
          });
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <div className="bg-black">
      {/* place-items-center */}
      {/* <ConnectWallet /> */}
      <div className="bg"></div>
      <div className="header ">
        <h1 className="text-8xl md:text-9xl text-center text-[#b27fff] mb-12">
          Lone Wolf Studios
        </h1>
      </div>
      <p className="text-white bay__title">
        LWS is a project housing a series of collections curated with separate
        goals in mind. With each collection interacting with one another. Our
        collections of Lone Wolf NFTs are unique digital assets living on the
        Ethereum blockchain. Your Lone Wolf grants access to members-only
        benefits.
      </p>
      <div className="mt-9">
        <a
          className=""
          href="/"
          onClick={(e) => {
            let hero = document.getElementById("Mint");
            e.preventDefault(); // Stop Page Reloading
            hero && hero.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
        >
          <span className="px-2 py-2 text-lg text-white btn btn-secondary mint-btn">
            Explore
          </span>
        </a>
      </div>
      <div class="slider">
        <div class="slide-track">
          {Array.from({ length: 18 }).map((_, i) => (
            <div class="slide" key={i}>
              <img
                className="sli"
                src={`/assets/images/wolf-${(i % 5) + 1}.png`}
                alt="placeholder"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="-mt-2">
        <h2 class="backroad">MINT MINT MINT MINT MINT MINT MINT MINT MINT MINT</h2>
        <h1 class="titleroad wolf" id="Roadmap">
          MINT
        </h1>
      </div>
      <div
        className="grid grid-cols-1 gap-4 pb-40 mt-10 md:grid-cols-2 place-items-center"
        id="Mint"
      >
        <div className="px-4 md:w-3/5 ">
          <img src="/assets/images/mint.png" alt="" className="mint-img" />
        </div>
        <div className="flex flex-col content-center gap-6">
          <p className="px-2 text-3xl mint-header text-[#895CCB] italic">
            GET YOUR LONE WOLF
          </p>
          <p className="w-3/4 mx-auto text-sm text-justify text-white md:text-base md:w-3/5 lg:text-center mint-text">
            When you buy a Lone Wolf, you're not simply buying a collectible or
            a provably-rare piece of art. You are joining a pack of unique
            individuals as well as gaining benefits and offerings that will
            increase over time. Your Lone Wolf can serve as your digital
            identity, and open digital doors for you.
          </p>
          {account ? (
            <div>
              <div className="flex flex-row gap-8 mb-4 text-white place-content-center">
                <button
                  className="px-2 text-lg text-white border border-white rounded-md bg-[#895CCB] w-7 h-7 flex justify-center items-center pb-[1px]"
                  onClick={decrement}
                >
                  -
                </button>
                {count}
                <button
                  className="px-2 text-lg text-white border border-white rounded-md bg-[#895CCB] w-7 h-7 flex justify-center items-center pb-[1px]"
                  onClick={increment}
                >
                  +
                </button>
              </div>
              <button
                className="px-2 py-2 text-lg text-white border border-white rounded-md bg-[#895CCB] w-64 self-center"
                onClick={handleMint}
              >
                Mint
              </button>
            </div>
          ) : (
            <button
              className="px-2 py-2 text-lg text-white border border-white rounded-md bg-[#895CCB] w-40 self-center"
              onClick={connectWallet}
            >
              Connect Wallet
            </button>
          )}
          <p className="text-lg text-center text-white">
            {userMinted}{" / "}{totalSupply}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Landing;
